import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';

import MoreActions from 'core/lab/MoreActions';
import ReloadButton from 'core/buttons/ReloadButton';
import ColumnVisibility from 'core/table/ColumnVisibility';
import SelectPartner from 'components/partners/SelectPartner';
import TableActionsContainer from 'core/table/TableActionsContainer';

import Auth from 'utils/Auth';
import Sheet from 'utils/Sheet';
import app from 'app/config/app';
import useQueryParams from 'hooks/useQueryParams';
import { getWebhookHeaders } from 'app/features/webhook-headers/webhookHeaderSaga';
import { setParam, resetParam } from 'app/features/webhook-headers/webhookHeaderSlice';
import isEmpty from 'helpers/isEmpty';

export default function WebhookHeadersActions({ table }) {
  const dispatch = useDispatch();

  const webhookHeaderState = useSelector((state) => state.webhookHeaders.index);

  const [queryParams, updateQueryParams] = useQueryParams(app.ignoreFilterKeys);

  const { params: appliedFilters } = webhookHeaderState;

  // const [search, setSearch] = useState(appliedFilters?.search ?? '');

  // const handleOnFilter = useCallback((data) => {
  //   dispatch(setParam({ ...data, page_number: 1 }));
  // }, []);

  // const handleOnSearch = useCallback((e) => {
  //   setSearch(e.target.value);
  //   debounce(() => {
  //     dispatch(setParam({ search: e.target.value, page_number: 1 }));
  //   }, 500);
  // }, []);

  // const handleOnClearSearch = useCallback(() => {
  //   setSearch('');
  //   dispatch(deleteFilterParams('search'));
  // }, []);

  // const handleOnReset = useCallback((e) => {
  //   dispatch(deleteFilterParams([...availableFilters.map((filter) => filter.value)]));
  // });

  useEffect(() => {
    updateQueryParams(appliedFilters);
    // setSearch(appliedFilters?.search ?? '');
  }, [JSON.stringify(appliedFilters)]);

  useEffect(() => {
    dispatch(setParam(queryParams));
  }, [JSON.stringify(queryParams)]);

  return (
    <TableActionsContainer>
      {/* <Box>
        <SearchBox
          onChange={handleOnSearch}
          onClickClearSearch={handleOnClearSearch}
          value={search || ''}
        />
      </Box> */}
      <Box display="flex" gap={1}>
        {Auth.isSuperAdmin() && (
          <SelectPartner
            id="select-partner"
            onSelected={(value) => {
              if (!isEmpty(value)) {
                dispatch(setParam({ partner_id: value }));
              } else {
                dispatch(resetParam());
              }
            }}
            sx={{ width: '200px', paddingRight: 2 }}
          />
        )}

        {/* <FilterPopup
          appliedFilters={appliedFilters}
          availableFilters={availableFilters}
          onFilter={(data) => handleOnFilter(data)}
          onReset={handleOnReset}
        /> */}
      </Box>

      <Box display="flex" gap={1}>
        {table && <ColumnVisibility table={table} />}
        <ReloadButton
          onClick={() => {
            dispatch(
              getWebhookHeaders({
                ...appliedFilters,
                page_number: 1,
                partnerId: webhookHeaderState.partnerId,
              }),
            );
          }}
        />
        <MoreActions
          onExportToCsv={() => Sheet.exportReactTableSelectedRowsToCsv(table, 'webhook_headers_')}
          onExportToExcel={() =>
            Sheet.exportReactTableSelectedRowsToExcel(table, 'webhook_headers_')
          }
        />
      </Box>
    </TableActionsContainer>
  );
}

WebhookHeadersActions.propTypes = {
  table: PropTypes.object,
};
